var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"close-icon pt-2 pr-2",attrs:{"color":_vm.color,"medium":""},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("mdi-close")])}
var staticRenderFns = []

export { render, staticRenderFns }